"use client";
import Image from "next/image";
import { usePathname } from "next/navigation";
import { HeroProps } from "../types";

/**
 * example input: "font-bold text-3xl lg:text-4xl"
 * output: "[&_h1]:font-bold [&_h1]:text-3xl lg:[&_h1]:text-4xl"
 */
const getTitleClassNames = (titleClassName: string | undefined) =>
  titleClassName
    ?.split(" ")
    .map((className) => {
      if (className.includes(":")) {
        return className
          .split(":")
          .map((item, index) => (index === 1 ? `[&_h1]:${item}` : item))
          .join(":");
      }
      return `[&_h1]:${className}`;
    })
    .join(" ") || "";

const BackgroundImage = ({
  children,
  image,
  mobileImage,
  titleClassName,
}: HeroProps) => {
  const titleClassNames = getTitleClassNames(titleClassName);

  const pathname = usePathname();
  const isProfEdPage = pathname === "/professional-education";
  const shouldHideImageOnMobile = !isProfEdPage && !mobileImage?.sourceUrl;

  return (
    <div
      className={
        image
          ? `relative md:px-4 pt-16 pb-8 lg:p-20 mx-break-out lg:bg-none ${shouldHideImageOnMobile ? "bg-primary-gradient from-secondary to-primary-500" : ""} [&_p]:text-white [&_p]:text-xl lg:[&_p]:text-[28px] [&_p]:font-bold ${titleClassNames || "[&_h1]:text-white [&_h1]:elm-d3 [&_h1]:2xl:elm-d4 [&_h1]:!leading-none [&_h1]:italic [&_h1]:font-black [&_h1]:mb-8"}`
          : titleClassNames
      }
    >
      {mobileImage?.sourceUrl && (
        <Image
          src={mobileImage.sourceUrl}
          priority
          fill
          alt={mobileImage.altText ?? ""}
          className={`bg-putty-700 absolute object-cover object-right m-0 z-[-1] block md:hidden"}`}
        />
      )}
      {image?.sourceUrl && (
        <Image
          src={image.sourceUrl}
          priority
          fill
          alt={image.altText ?? ""}
          className={`bg-putty-700 absolute object-cover object-[right_25%] m-0 z-[-1] ${isProfEdPage ? "block" : shouldHideImageOnMobile ? "hidden lg:block" : "hidden md:block"}`}
        />
      )}
      <div className="container flex pb-8">
        <div className="lg:basis-2/3">{children}</div>
      </div>
    </div>
  );
};

export default BackgroundImage;
